import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import { onShowInfoClick } from '../../../_views/configurator/on_show_info';

function ConfiguratorFindSizeInfoLayer(props) {
  return (
    <div style={{ padding: props.isInnerText ? '0 0 15px' : '0 15px 15px', width: '100%', float: 'left' }}>
      {props.heading && (
        <Translation
          translationKey="catalog-configurator-find-size-header-text"
          tagName="span"
          style={{ fontSize: '16px' }}
        />
      )}

      {props.text && (
        <Translation
          translationKey="catalog-configurator-find-size-sub-text"
          tagName="span"
          className="configurator-info-layer__more-information"
          href="/"
          onClick={() => onShowInfoClick(props.type)}
          style={{ margin: '0' }}
        />
      )}
    </div>
  );
}

ConfiguratorFindSizeInfoLayer.propTypes = {
  type: PropTypes.string.isRequired,
};

export default ConfiguratorFindSizeInfoLayer;
